import { createContext, useContext, useState } from "react";

const UIContext = createContext({ focusMode: false, setFocusMode: () => {} });

export const UIProvider = ({ children }) => {
  const [focusMode, setFocusMode] = useState(false);
  return <UIContext.Provider value={{ focusMode, setFocusMode }}>{children}</UIContext.Provider>;
};

export const useUI = () => useContext(UIContext);
